import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-inner">
        <div className="footer-column contact-column">
          <h4 className="footer-heading">Contact</h4>
          <div className="footer-content">
            <p>P.O. Box 29818</p>
            <p>Los Angeles, CA 90029</p>
            <p>
              <a href="mailto:service@pmistpearl.work">service@pmistpearl.work</a>
            </p>
          </div>
        </div>

        <div className="footer-column info-column">
          <h4 className="footer-heading">Info</h4>
          <div className="footer-content">
            <p>
              <Link to="/privacy" onClick={toTop}>
                Privacy Policies
              </Link>
            </p>
            <p>
              <Link to="/terms" onClick={toTop}>
                Terms & Conditions
              </Link>
            </p>
            <p>
              <Link to="/returns" onClick={toTop}>
                Returns
              </Link>
            </p>
            <p>
              <Link to="/shipping" onClick={toTop}>
                Delivery
              </Link>
            </p>
            <p><Link to="/faqs" onClick={toTop}>FAQs</Link></p>
            <p><Link to="/cookies" onClick={toTop}>Cookie Policy</Link></p>
          </div>
        </div>

        <div className="footer-column copyright-column">
          <p>© 2026 pmistpearl</p>
          <div className="payment-methods" aria-label="Accepted payment methods">
            <span>VISA</span><span>Mastercard</span><span>AMEX</span><span>JCB</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
